import React from "react";

import Body from "./Body";
import Col from "./Col";
import Footer from "./Footer";
import Header from "./Header";
import Pagination from "./Pagination";
import Row from "./Row";

function Table({ children, ...props }) {
  // Rediseño: borde fino alrededor de la grilla (sin overflow en el contenedor, para no recortar menús de las filas)
  return (
    <div className="rounded-lg border border-line dark:border-line-dark">
      <table
        className="w-full text-sm text-left text-gray-700 dark:text-gray-300 rounded-lg overflow-hidden"
        {...props}
      >
        {children}
      </table>
    </div>
  );
}

Table.Body = Body;
Table.Header = Header;
Table.Footer = Footer;
Table.Row = Row;
Table.Col = Col;
Table.Pagination = Pagination;

export default Table;
